export default "__VITE_ASSET__Cumd2FvM__"